export const STAGE_LABELS = {
  NEW: "New", AI_QUALIFIED: "AI Qualified", ASSIGNED: "Assigned", CONTACTED: "Contacted",
  QUOTATION: "Quotation", FOLLOW_UP: "Follow-Up", WON: "Won", LOST: "Lost",
};
export const STAGES = ["NEW", "AI_QUALIFIED", "ASSIGNED", "CONTACTED", "QUOTATION", "FOLLOW_UP", "WON", "LOST"];

export const STAGE_COLORS = {
  NEW: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  AI_QUALIFIED: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300",
  ASSIGNED: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300",
  CONTACTED: "bg-cyan-100 text-cyan-700 dark:bg-cyan-950 dark:text-cyan-300",
  QUOTATION: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  FOLLOW_UP: "bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-300",
  WON: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  LOST: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300",
};

export const TIER_COLORS = {
  HOT: "bg-rose-100 text-rose-700",
  WARM: "bg-amber-100 text-amber-700",
  COLD: "bg-slate-100 text-slate-600",
};

export const scoreColor = (s) =>
  s >= 85 ? "bg-rose-100 text-rose-700" : s >= 60 ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600";

export const fmtRM = (n) => "RM" + (n || 0).toLocaleString("en-MY");

export const INBOX_FILTERS = [
  { key: "ALL", label: "All" }, { key: "NEW", label: "New" }, { key: "AI_HANDLING", label: "AI Handling" },
  { key: "WAITING_STAFF", label: "Waiting Staff" }, { key: "MY_CHATS", label: "My Chats" },
  { key: "HOT_LEADS", label: "Hot Leads" }, { key: "FOLLOW_UP", label: "Follow-Up" }, { key: "CLOSED", label: "Closed" },
];

export const CHANNELS = [
  { key: "ALL", label: "Semua" },
  { key: "WHATSAPP", label: "WhatsApp" },
  { key: "MESSENGER", label: "Messenger" },
  { key: "INSTAGRAM", label: "Instagram" },
  { key: "COMMENT", label: "Comments" },
];

export const CHANNEL_META = {
  whatsapp: { label: "WhatsApp", cls: "text-emerald-600 bg-emerald-100", dot: "bg-emerald-500" },
  messenger: { label: "Messenger", cls: "text-blue-600 bg-blue-100", dot: "bg-blue-500" },
  instagram: { label: "Instagram", cls: "text-pink-600 bg-pink-100", dot: "bg-pink-500" },
  comment: { label: "Comment", cls: "text-violet-600 bg-violet-100", dot: "bg-violet-500" },
};
